import {
  WSPageToolbar,
  WSPageToolbarAction,
  WSText
} from "@wingspanhq/fe-component-library";
import { SubscriptionStatus } from "@wingspanhq/users/dist/lib/interfaces/subscription";
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../query/hooks/helpers";
import {
  useQuerySubscriptionPackages,
  useQuerySubscriptionV3
} from "../../../query/subscriptions/queries";
import { PATH_BENEFITS_ENROLL } from "../paths";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";

const ACTIVE_STATUSES: ReadonlyArray<SubscriptionStatus> = [
  SubscriptionStatus.active,
  SubscriptionStatus.trialing
];

export const PremiumPerksPageHeader: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();
  const qSubscription = useQuerySubscriptionV3(userId);
  const qSubscriptionPackages = useQuerySubscriptionPackages();

  const isSubscribed = ACTIVE_STATUSES.includes(
    qSubscription.data?.status as SubscriptionStatus
  );

  const monthlyPackage = qSubscriptionPackages.data?.Benefits?.Basic?.Monthly;
  const monthlyCost = monthlyPackage?.amount ?? 0;
  const currency =
    (monthlyPackage?.currency?.toUpperCase() as Currency) ?? Currency.USD;

  const actions = useMemo<WSPageToolbarAction[]>(() => {
    if (isSubscribed) {
      return [];
    }

    return [
      {
        label: "Enroll now",
        buttonKind: "Primary",
        onClick: () => {
          history.push({
            pathname: PATH_BENEFITS_ENROLL,
            state: {
              backPath: history.location.pathname
            }
          });
        }
      }
    ];
  }, [isSubscribed, history]);

  const subtitle = isSubscribed
    ? "See what's included in your subscription below."
    : `Get access to a full benefits suite for ${formatMoney(
        monthlyCost,
        currency
      )}/month once you enroll in the Premium Perks subscription. See what’s included in the subscription below.`;

  return (
    <WSPageToolbar title="All Premium Perks" actions={actions}>
      {subtitle && (
        <WSText.ParagraphSm color="gray500">{subtitle}</WSText.ParagraphSm>
      )}
    </WSPageToolbar>
  );
};
